<template>
    <div id="us-all-Journey-cart1">
        <div class="" id="pageination" v-if="!loading">
            <div class="Detail_AllJourney col-lg-12 col-md-12 col-sm-12 col-xs-12" v-for="(journey, journeyid) in Jcarts" :key="journey.id_jrn_journey + '_' + journeyid">
                <!-- <pre>{{ journey }}</pre> -->
                <div class="Detail_JourneyContent">
                    <div
                        class="Detail_LitPic"
                        :style="
                            'position:relative;cursor: pointer; background-position: center center; background-image: url(\'' +
                                getJourneyImage(journey) +
                                '\'); background-repeat: no-repeat; background-size: ' +
                                (getJourneyImage(journey) == '/images/koennecke-2.png' ? 'contain' : 'cover') +
                                ';'
                        "
                        @click="navigateJourney(journey)"
                    >
                        <div v-if="journey.img.images[0]" style="position:absolute;bottom:5px;right:5px;color:#fff;text-shadow: 0px 0px 2px #000000;font-size:11px;">
                            
                            <!-- {{journey.img.images[0]}} -->
                            
                            {{ journey.img.images[0].copyright}}
                        </div>
                    </div>
                    <div class="Detail_ReiseTitel">{{ journey.title }}</div>
                    <div class="Detail_ReiseEinleitung">
                        <div class="ellipsify">
                            {{ journey.img.subtitle }}
                        </div>
                    </div>

                    <div class="Detail_ReiseDauer">
                        <div class="DauerDatum">
                            {{ getJourneyDates(journey) }}
                        </div>
                        <div class="DauerTag">{{ journey.duration }} Tag<span v-if="journey.duration != 0">e</span></div>

                        <hr />
                    </div>

                    <div class="Detail_ReisePreis">
                        <div v-if="journey.price == 0" class="preis">auf Anfrage</div>
                        <div v-else class="preis">{{ journey.price / 1000000 }},- €</div>
                        <div class="mehr" @click="navigateJourney(journey)">
                            <img src="../assets/images/btn_more1.png" style="height:35px;margin-left:10px;cursor:pointer;" />
                        </div>
                    </div>

                    <!-- <input disabled="disabled" type="hidden" name="tmpdname0" id="tmpdid0" value="" />
                    <input disabled="disabled" type="hidden" name="tmpname0" id="tmpid0" value="Kururlaub an der poln. Ostsee in Kolberg" /> -->
                </div>
            </div>
        </div>
        <div v-else><Loader></Loader></div>
        <!-- <div class="edt-cont-box-ov-pgn clearfix">
            <div class="col-md-4">
                <h2 class="edt-text-orange">{{ journeyCategory }} </h2>
            </div>
            <div class="col-md-4 edt-pagination"></div>
        </div> -->
    </div>
</template>

<script>
import { mapState } from "vuex";
import Loader from "./Loader";
export default {
    props: ["search"],
    computed: {
        ...mapState(["JourneyStoreSingle", "Settings", "JourneyCategoryStore", "SearchStore"]),
    },
    components: {
        Loader,
    },
    watch: {
        JourneyStoreSingle(newValue, oldValue) {
            // if (this.args.category === "search") {
            // } else if (this.args.category === "Tagesfahrten") {
            //     this.Jcarts = this.JourneyStoreSingle.filter((jrn) => jrn.duration === 1);
            //     this.Jcarts = this.Jcarts.sort((a, b) => new Date(a.date_from) - new Date(b.date_from));
            // } else if (this.args.category === "Mehrtagesfahrten") {
            //     this.Jcarts = this.JourneyStoreSingle.filter((jrn) => jrn.duration > 1);
            //     this.Jcarts = this.Jcarts.sort((a, b) => new Date(a.date_from) - new Date(b.date_from));
            // } else {
            //     this.Jcarts = this.JourneyStoreSingle;
            //     this.Jcarts = this.Jcarts.sort((a, b) => new Date(a.date_from) - new Date(b.date_from));
            // }
        },
    },
    mounted() {
        setTimeout(() => {
            this.args = core.getPathArgs(["category", "search"]);

            try {
                this.journeyCategory = this.JourneyCategoryStore.find((cat) => cat.name == decodeURIComponent(this.args.category)).id_jrn_category;
            } catch (error) {
                this.journeyCategory = "";
            }
            let args = {
                id_acc_account: core.id_acc_account,
                category: this.journeyCategory,
                active_only: true,
            };

            if (this.args.category == "search") {
                this.$store.commit("updateSearchStore", JSON.parse(this.args.search));
                args.country = this.SearchStore.country == null ? null : [this.SearchStore.country];
                args.category = this.SearchStore.category == null ? null : [this.SearchStore.category];
                args.search = this.SearchStore.search;
                args.project = this.SearchStore.project;
                args.duration = this.SearchStore.duration;
                args.date = this.SearchStore.dateRange == null ? null : {start: this.SearchStore.dateRange[0], end: this.SearchStore.dateRange[1]};
            }
            core.backend("jrn.listJourneysWeb", args, (err, res) => {
                if (err) {
                    return;
                }
                res.data.rows.forEach((jrney) => {
                    let _newJourney = JSON.parse(JSON.stringify(jrney));
                    _newJourney.dates = [];
                    jrney.dates.forEach((date) => {
                        if (date.price === 0) {
                            // return;
                        }
                        _newJourney.dates.push(date);
                    });
                    try {
                        this.Jcarts.push({
                            title: _newJourney.title,
                            date_from: _newJourney.dates[0].date_from,
                            date_till: _newJourney.dates[0].date_till,
                            einleitung: _newJourney.einleitung,
                            reisebeschreibung: _newJourney.reisebeschreibung,
                            duration: _newJourney.dates[0].duration,
                            price: _newJourney.dates.sort((a, b) => a.price - b.price)[0].price,
                            id_jrn_journey: _newJourney.id_jrn_journey,
                            id_prj_project: _newJourney.id_prj_project,
                            img: _newJourney,
                            dates: _newJourney.dates,
                        });
                    } catch (error) {}
                });
                
                console.log(this.Jcarts)
                
                
                this.Jcarts = this.shuffle(this.Jcarts);
            });
        }, 1000);
    },

    data() {
        return {
            Jcarts: [],
            args: {},
            journeyCategory: "",
            loading: false,
        };
    },
    methods: {
        formatter(row, column, cellValue, index) {
            return new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(cellValue));
        },
        formatterPrice(row, column, cellValue, index) {
            var num = cellValue / 1000000;
            return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €";
        },
        goToDetail(row) {
            core.navigate({ path: "/journeydetail/" + row.id_jrn_journey });
        },
        sortDateFrom(a, b) {
            return new Date(a.date_till) < new Date(b.date_till);
            // console.log(new Date(a.date_from).getTime() < new Date(b.date_from).getTime());
            // return false;
            return new Date(a.date_from).getTime() < new Date(b.date_from).getTime();
        },
        sortDateTill(a, b) {
            return new Date(a.date_till) > new Date(b.date_till);
        },
        sortDuration(a, b) {
            return a.duration > b.duration;
        },
        sortPrice(a, b) {
            return a.price > b.price;
        },
        onSort({ column, prop, order }) {
            this.Settings.journeyoverview.defaultsort = { prop, order };
        },
        getJourneyImage(jrn) {
            try {
                return jrn.img.images[0].link;
            } catch (e) {
                return "/images/koennecke-2.png";
            }
        },
        getJourneyDates(jrn) {
            let _dates = [];
            jrn.img.dates.forEach((jd) => {
                _dates.push(this.getJourneyDate(jd));
            });
            return _dates.join(", ");
        },
        getJourneyDate(jrn) {
            if (jrn.date_from == jrn.date_till) {
                return new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(jrn.date_from));
            }
            return (
                new Intl.DateTimeFormat("de-DE", { month: "2-digit", day: "2-digit" }).format(new Date(jrn.date_from)) +
                " - " +
                new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(jrn.date_till))
            );
        },
        navigateJourney(jrn) {
            core.navigate({ path: "/journeydetail/" + jrn.id_jrn_journey });
        },
    },
};
</script>

<style lang="scss">
#us-all-Journey-cart {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
    align-self: flex-end;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.image-slot-error {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
}

#JourneySiteListe {
    position: relative;
    top: 5px;
    margin-bottom: 35px;
}

#JourneyTreffer {
    line-height: 30px;
    font-weight: bold;
}

.KaredMonate {
    line-height: 20px;
    color: #86063f;
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid #86063f;
    margin-bottom: 10px;
    margin-top: 10px;
}

#JourneySiteListe a {
    color: #f78a27 !important;
}
#JourneySiteListe td {
    border-bottom: 1px solid #e5e5e5;
}

#JourneySite {
    position: relative;
    top: 5px;
    margin-bottom: 35px;
    width: 100%;
}

#JourneyTreffer {
    /* line-height:30px;
color:#157ab8;
font-size:24px;
font-weight:bold; 
margin-bottom:10px; */
    display: none;
}

.KaredReiseStoerer {
    /* position:absolute;
width:100px;
height:50px;
top:-15px;
right:-15px;
z-index:99; */
    display: none;
}
@media screen and (min-width: 1175px) {
    // .Detail_AllJourney {
    //     width: 49.5% !important;
    // }
}
.Detail_AllJourney {
    background-color: #e5e5e5;
    /* display:inline-block;  */
    margin-bottom: 10px;
    margin-right: 8px;

    /* height:135px; */
    /* padding:10px; 
line-height:25px;
-webkit-box-shadow: 2px 2px 10px 2px rgba(179,179,179,1);
-moz-box-shadow: 2px 2px 10px 2px rgba(179,179,179,1);
box-shadow: 2px 2px 10px 2px rgba(179,179,179,1);*/
}

.Detail_AllJourney:nth-child(even) {
    margin-right: 0 !important;
}

.Detail_JourneyContent {
    position: relative;
}

.Detail_ReiseTitel {
    position: absolute;
    top: 0px;
    width: -moz-available;
    font-size: 16px;
    text-transform: uppercase;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-left: 200px;
    background-color: #86063f;
    padding: 10px;
    height: 35px;
    font-weight: bold;
    color: #fff;
}
.Detail_ReiseEinleitung {
    margin-left: 200px;
    top: 55px;
    font-size: 11px;
    height: 50px;
    line-height: 120%;
    position: absolute;
    width: -moz-available -webkit-fill-available;
    padding: 10px;
    font-weight: bold;
}
.ellipsify {
    font-size: 14px;
    height: 50px;
    line-height: 120%;
    overflow: hidden;
    position: relative;
    text-align: left;
    width: 95%;
    word-wrap: break-word;
}

.pre-dots {
    float: right;
    height: 36px;
}

.dots {
    float: right;
    clear: right;
}

.hidedots1 {
    width: 100%;
    height: 120%;
    position: absolute;
}

.hidedots2 {
    width: 100%;
    height: 54px;
    position: absolute;
}

@media screen and (max-width: 500px) {
    .Detail_LitPic {
        width: 75px !important;
    }
    .Detail_ReiseDauer {
        margin-left: 75px !important;
    }
    .Detail_ReisePreis {
        margin-left: 75px !important;
    }
    .Detail_ReiseTitel {
        margin-left: 75px !important;
    }
}

.Detail_LitPic {
    /* display:inline-block; */
    width: 200px;
    height: 210px;
    /* border:1px solid #000; */
}
.Detail_ReiseDauer {
    position: absolute;
    top: 120px;
    right: 0;
    color: #86063f;
    width: -moz-available;
    margin-left: 200px;
    color: #86063f;
    font-weight: bold;
}
.Detail_ReiseDauer .DauerDatum {
    float: left;
    padding: 10px;
}
.Detail_ReiseDauer .DauerTag {
    float: right;
    padding: 10px;
}
.Detail_ReiseDauer hr {
    clear: both;
}
.Detail_ReisePreis {
    position: absolute;
    top: 160px;
    right: 0;
    color: #000;
    width: -moz-available;
    margin-left: 200px;
    font-size: 20px;
    font-weight: bold;
}
.Detail_ReisePreis .preis {
    padding: 10px;
    float: left;
}
.Detail_ReisePreis .mehr {
    padding: 10px;
    float: right;
}
.Detail_ReiseMehr a {
    color: #676767;
}
.Detail_ReiseMehrButton {
    position: absolute;
    top: 7px;
    right: -14px;
    width: 10px;
    height: 10px;
    /* background:url(../images/mehr.jpg);  */
}

.Detail_KaredBlaetternModul {
    text-align: center;
    width: 100% !important;
    margin: 0 !important;
    /* float:none !important; */
}

.Detail_KaredBlaetternModul a {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin: 2px;
    border: 1px solid #979797;
    background-size: cover;
    color: #86063f;
    /* background-image:url(/images/site_left.png); */
}

.Detail_KaredBlaetternModul a:hover,
.seitenNavi.active {
    /* color:#86063F; */
    color: #fff;
    background-color: #86063f;
    font-style: none !important;
    text-decoration: none;
}

// .seitenEnd{
// 	background-image:url(../images/site_right.png);
// }
// .seitenStart{
// 	background-image:url(../images/site_left.png);
// }.seitenEnd:hover{
// 	background-image:url(../images/site_right_a.png);
// }
// .seitenStart:hover{
// 	background-image:url(../images/site_left_a.png);
// }

// .Rend {background:url(../images/ende.jpg) no-repeat;}
// .Rstart {background:url(../images/start.jpg) no-repeat;}
// .Rvor {background:url(../images/vor.jpg) no-repeat;}
// .Rret {background:url(../images/zurueck.jpg) no-repeat;}

.ui-dialog-titlebar {
    background: #86063f !important;
}

/* 
@media screen and (-webkit-min-device-pixel-ratio:0)
  and (min-resolution:.001dpcm) {
    .Detail_ReisePreis, .Detail_ReiseDauer, .Detail_ReiseEinleitung, .Detail_ReiseTitel{width:-webkit-fill-available;} 
}


@media screen and(-webkit-min-device-pixel-ratio:0) {
  .Detail_ReisePreis, .Detail_ReiseDauer, .Detail_ReiseEinleitung, .Detail_ReiseTitel{-chrome-:only(; 
     width:-webkit-fill-available;
  );} 
}

@supports (-ms-accelerator:true) {
.Detail_ReisePreis, .Detail_ReiseDauer, .Detail_ReiseEinleitung, .Detail_ReiseTitel{width:-webkit-fill-available; !important} 
} */

.Detail_ReisePreis,
.Detail_ReiseDauer,
.Detail_ReiseEinleitung,
.Detail_ReiseTitel {
    width: 75%;
    width: -moz-available; /* WebKit-based browsers will ignore this. */
    width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
}
</style>
